const state = {

   airports:null,
    selFlight:null,
    orgBindedFlightLs:null,
    selSortValue: null,
    searchPricingReq: null,
    searchRes: null,
    selectedPricingObj: null,
    selFlightObjFrmPric: null,
    airlines: null,
    currencyObj: null,
    BindedFlightLs:null,
    airports:null,
    FilterData:[],
    
    DispfilterLs:[],
    cheapestLs:[],
    selPriceForFooter:null
};

const getters = {
    GET_ORG_BINDED_FLIGHT_LS: (state) => {
        return state.orgBindedFlightLs;
    },
    
    GET_FILTER_DATA: (state) => {
        return state.FilterData;
    },
    
    GET_FLIGHT_OBJ: (state) => {
        return state.selFlight;
    },
    
    GET_SEL_SORT_OBJ: (state) => {
        return state.selSortValue;
    },
    
    GET_SEL_PRICING_OBJ: (state) => {
        return state.selectedPricingObj;
    },
    GET_SEL_FLI_FRM_PRIC: (state) => {
        return state.selFlightObjFrmPric;
    },
    GET_ML_AIRPORTS: (state) => {
        return state.airports;
    },
    GET_ML_AIRLINES: (state) => {
        return state.airlines;
    },
    GET_CURRENCY: (state) => {
        return state.currencyObj;
    },

    GET_SEARCH_PRICING_REQ: (state) => {
        return state.searchPricingReq;
    },
    GET_SEARCH_RES: (state) => {
        return state.searchRes;
    },
    GET_BINDED_FLIGHT_LS: (state) => {
        return state.BindedFlightLs;
    },
    GET_DISP_FILTER_LS: (state) => {
        return state.DispfilterLs;
    },
    
    GET_ML_CHEAPEST_LS: (state) => {
        return state.cheapestLs;
    },
    GET_SELFLIGHT_FOR_FOOTER: (state) => {
        return state.selPriceForFooter;
    }



};


const actions = {
    
    SET_ORG_BINDED_FLIGHT_LS: ({ commit }, orgBindedFlightLs) => {
        commit('saveOrgBindedFlightLs', orgBindedFlightLs)
    },

    CLEAR_ML_RESULT_STORE: ({ commit }) => {
        commit('clearResultStore');
    },
    SET_ML_CHEAPESTLS: ({ commit }, cheapestLs) => {

        commit('saveCheapestLs', cheapestLs);

    },
    SET_SELFLIGHT_FOR_FOOTER: ({ commit }, pric) => {

        commit('saveSelPricForFooter', pric);

    },
    SET_ML_AIRPORTS: ({ commit }, airPorts) => {

        commit('saveAirPorts', airPorts);

    },

    SET_ML_AIRLINES: ({ commit }, airlines) => {

        commit('saveAirLines', airlines);

    },
    SET_CURRENCY: ({ commit }, currency) => {

        commit('saveCurrencyObj', currency);

    },

    
    SET_FILTER_DATA: ({ commit }, filters) => {

        commit('saveFilterData', filters);

    },
   
    SET_FLIGHT_OBJ: ({ commit }, selFlight) => {

        commit('saveSelFlightObj', selFlight);

    },
    SET_SEL_SORT_OBJ: ({ commit }, selSort) => {

        commit('saveselSortObj', selSort);

    },
    // SET_SEL_PRICING_OBJ: ({ commit }, selectedPricing) => {

    //     commit('saveSelectedPricing', selectedPricing);

    // },

    SET_SEL_FLI_FRM_PRIC: ({ commit }, selFlightFrmPric) => {

        commit('saveSelFliFrmPric', selFlightFrmPric);

    },

    SET_SEARCH_PRICING_REQ: ({ commit }, searchPricingReq) => {
        commit('saveSearchPricingReq', searchPricingReq)
    },

    SET_SEARCH_RES: ({ commit }, searchRes) => {
        commit('saveSearchRes', searchRes)
    },
    SET_BINDED_FLIGHT_LS: ({ commit }, BindedFlightLs) => {
        commit('saveBindedFlightLs', BindedFlightLs)
    },
    SET_DISP_FILTER_LS: ({ commit }, DispfilterLs) => {
        commit('saveDisplayFilterLs', DispfilterLs)
    },
    



};


const mutations = {
    clearResultStore: (state) => {
        state.orgBindedFlightLs=null;
        state.cheapestLs=null;
        state.selFlight = null;
        state.airports = null;
        state.selSortValue = null;
        state.selectedPricingObj = null;
        state.selFlightObjFrmPric = null;
        state.searchPricingReq = null;
        state.searchRes = null;
        state.BindedFlightLs=null;
        state.FilterData=null;
        
        state.DispfilterLs=null;
       
        state.airlines=null;
        state.currencyObj=null;
    },

    saveAirPorts: (state, airports) => {
        state.airports = airports;
    },

    saveOrgBindedFlightLs: (state, orgBindedFlightLs) => {
        state.orgBindedFlightLs = orgBindedFlightLs;
    },

    saveCheapestLs: (state, cheapestLs) => {
        state.cheapestLs = cheapestLs;
    },
    saveFilterData: (state, FilterData) => {
        state.FilterData = FilterData;
    },
    
    saveBindedFlightLs: (state, BindedFlightLs) => {
        state.BindedFlightLs = BindedFlightLs;
    },
    saveDisplayFilterLs: (state, dispfilterLs) => {
        state.DispfilterLs = dispfilterLs;
    },
    saveibDisplayFilterLs: (state, ibdispfilterLs) => {
        state.ibdispfilterLs = ibdispfilterLs;
    },
    saveCurrencyObj: (state, currencyObj) => {
        state.currencyObj = currencyObj;
    },
    saveAirLines: (state, airlines) => {
        state.airlines = airlines;
    },
   
    
    saveSelFlightObj: (state, selFlight) => {
        state.selFlight = selFlight;

    },
    
    saveselSortObj: (state, selSort) => {

        state.selSortValue = selSort;
    },
    
    saveSelectedPricing: (state, selectedPricing) => {
        state.selectedPricingObj = selectedPricing;
    },
    saveSelFliFrmPric: (state, selFlightFrmPric) => {
        state.selFlightObjFrmPric = selFlightFrmPric;
    },


    saveSearchPricingReq: (state, searchPricingRequest) => {
        state.searchPricingReq = searchPricingRequest;
    },
    saveSearchRes: (state, searchRes) => {
        state.searchRes = searchRes;
    },
    
    saveSelPricForFooter: (state, pric) => {
        state.selPriceForFooter = pric;
    },

};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}